/**
 * Newsletter Modal - Mobile Only
 * Shows newsletter popup on page load on mobile devices
 */

(function() {
  // Only run on mobile devices (749px matches Dawn theme convention)
  if (window.innerWidth > 749) return;

  const modal = document.querySelector('[data-newsletter-modal]');
  const backdrop = document.querySelector('[data-newsletter-backdrop]');

  if (!modal || !backdrop) return;

  const content = modal.querySelector('.newsletter-modal__content');

  // The popup has no fixed height, so the banner copy can only clear it from a
  // measured value. Recalculated whenever that height can change.
  function setModalHeight() {
    if (!content) return;
    document.documentElement.style.setProperty('--newsletter-modal-height', `${content.offsetHeight}px`);
  }

  setModalHeight();
  window.addEventListener('resize', setModalHeight);
  window.addEventListener('orientationchange', setModalHeight);

  // Show modal immediately on load (delay removed per client request)
  const passwordModal = document.querySelector('[data-password-modal]');
  if (!(passwordModal && passwordModal.classList.contains('is-visible'))) {
    modal.classList.add('is-visible');
  }

  // Close modal when clicking backdrop
  backdrop.addEventListener('click', () => {
    modal.classList.remove('is-visible');
  });

  // Close modal after successful subscription
  const newsletterElement = modal.querySelector('newsletter-custom');
  if (newsletterElement) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains('is-success')) {
          // The success state is shorter than the form, so re-measure
          setModalHeight();

          // Close modal after 3 seconds of showing success message
          setTimeout(() => {
            modal.classList.remove('is-visible');
          }, 3000);
        }
      });
    });

    observer.observe(newsletterElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();
